import React, { useState } from "react";
import { Dialog, Button, CustomerHubIcon, TextArea, Flex, EmojiIcon } from "@fluentui/react-northstar";
import { useAppInsightsContext, useTrackEvent } from "@microsoft/applicationinsights-react-js";
import styles from "./FeedbackDialog.module.scss";
import pl from "shared/messages/pl";
import { FeedbackGiven } from "appilication-insights/events/FeedbackGiven/FeedbackGiven";
import { trackEvent } from "appilication-insights/ApplicationInsightsUtils";

interface Feedback {
    input: string;
}

export const FeedbackDialog: React.FC = () => {
    const [show, setShow] = useState(false);
    const [feedback, setFeedback] = useState<Feedback>({ input: "" });
    const [inputRequired, setInputRequired] = useState(false);
    const [thankYou, setThankYou] = useState(false);

    const appInsights = useAppInsightsContext();

    const reset = () => {
        setShow(false);
        setFeedback({ input: "" });
        setInputRequired(false);
        setThankYou(false);
    };

    const onSendButtonClicked = () => {
        if (thankYou) {
            reset();
            return;
        }

        if (feedback.input === "") {
            setInputRequired(true);
            return;
        }

        const ev = new FeedbackGiven(feedback.input);
        trackEvent(appInsights, ev, ev.getCustomProperties());

        setThankYou(true);
    };

    const renderThankYou = () => (
        <Flex className={styles.thankYouDialog} hAlign="center" vAlign="center">
            <EmojiIcon outline size="largest" />
        </Flex>
    );

    const renderContent = () => (
        <TextArea
            value={feedback.input}
            onChange={(_, props) => setFeedback({ ...feedback, input: props?.value ?? "" })}
            error={inputRequired}
            fluid
            maxLength={1000}
            className={styles.textarea}
            placeholder={pl.feedback.textAreaPlaceholder}
        />
    );

    return (
        <Dialog
            open={show}
            header={
                thankYou
                    ? pl.feedback.thankYouMessage
                    : pl.feedback.invitationMessage
            }
            content={thankYou ? renderThankYou() : renderContent()}
            confirmButton={thankYou ? pl.common.continue : pl.common.send}
            onConfirm={onSendButtonClicked}
            cancelButton={thankYou ? undefined : pl.common.cancel}
            onCancel={reset}
            trigger={
                <Button
                    className={styles.button}
                    onClick={() => setShow(true)}
                    icon={<CustomerHubIcon size="large" />}
                    text
                    iconOnly
                    title={pl.feedback.title}
                />
            }
        />
    );
};
